type DictionaryFuncType = (value: string, dictionary: Record<string, string>) => string;

export const dictionaryLookup: DictionaryFuncType = (value, dictionary) =>
  dictionary[value] || value;
